// extracted by mini-css-extract-plugin
export default {"readOnlyInput":"FeeCalculator_readOnlyInput__uxcGK","feeCalculator":"FeeCalculator_feeCalculator__A3QJf"};